import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { ValoracionCliente } from 'src/app/home/_models/valoracion-cliente';

@Component({
  selector: 'app-ficha-valoracion-cliente',
  templateUrl: './ficha-valoracion-cliente.component.html',
  styleUrls: ['./ficha-valoracion-cliente.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
  ]
})

export class FichaValoracionClienteComponent
{
  @Input() valoracion: ValoracionCliente;
}
